module.exports = __webpack_public_path__ + "img/流体力学3_1.064a593f.jpg";